module.exports = __webpack_public_path__ + "img/squeleton-blessing.656dc073.png";